import { render, staticRenderFns } from "./ItemDetail.vue?vue&type=template&id=0f1e56eb&lang=pug&"
import script from "./ItemDetail.vue?vue&type=script&lang=js&"
export * from "./ItemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports